import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from '../../organization/hooks/useSelectedOrganization';
import { GET_CONVERSATIONS_QUERY_KEY } from './useListConversations';

export const useDeleteConversation = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: (conversationId: string) => {
            if (!selectedOrganization?.id) {
                return Promise.reject(new Error('No organization selected'));
            }
            return client.fetchApi<{ deleted: number }, {}>({
                endpoint: `whatsapp-conversations/${selectedOrganization.id}/${conversationId}`,
                method: 'DELETE',
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: GET_CONVERSATIONS_QUERY_KEY(
                    selectedOrganization?.id || '',
                ),
            });
        },
    });
};
